import React, { useEffect } from "react";
import "../assets/css/osmanliyatirim.css";

const Home = (props) => {
  useEffect(() => {
    if (document.getElementById("loader").style.display !== "none") {
      setTimeout(() => {
        document.getElementById("loader").style.display = "none";
      }, 2000);
    }
  }, []);

  return (
    <>
      <div className="loader-container" id="loader">
        <div className="holder">
          <div className="la-line-scale la-2x">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="container-box row d-flex align-items-center">
          {/* LEFT: Feature List */}
          <div className="col-md-6">
            <div className="text_box">
              <strong>Osmanlı Yatırım'a Hoş Geldiniz!</strong>
              <ul>
                <li>
                  <img className="text_box_number" src="images/number.svg" alt="" />
                  <p>Tüm sözleşme ve dökümanları online onay ve takip,</p>
                </li>
                <li>
                  <img className="text_box_number" src="images/number.svg" alt="" />
                  <p>Hisse, viop, varant, fon, bono ve bes ürünlerinde kolay analiz ve işlemler,</p>
                </li>
                <li>
                  <img className="text_box_number" src="images/number.svg" alt="" />
                  <p>E-şube ve diğer web/mobil uygulamalarımızda gelişmiş emir ve portföy takip ekranları,</p>
                </li>
                <li>
                  <img className="text_box_number" src="images/number.svg" alt="" />
                  <p>İşlem hacmi veya fon/bes büyüklüğü ile ücretsiz anlık, derinlikli ve akd lisansları kullanımı,</p>
                </li>
                <li>
                  <img className="text_box_number" src="images/number.svg" alt="" />
                  <p>Size uygun müşteri temsilcisi ve destek hizmeti</p>
                </li>
                <li className="osmanli-info-row">
                  <span className="osmanli-info-icon">i</span>
                  <p className="osmanli-info-text">
                    Hesap açma işlemlerinizi haftanın her günü 09:00-20:00 saatleri arasında gerçekleştirebilirsiniz.
                  </p>
                </li>
                <li className="osmanli-info-row">
                  <span className="osmanli-info-icon">i</span>
                  <p className="osmanli-info-text">
                    Görüntülü Hesap Açılış sürecine ilişkin detaylı anlatımın yer aldığı videomuza ulaşmak için <a href="https://www.youtube.com/watch?v=Gysk90jqdXA&feature=youtu.be" target="_blank" rel="noreferrer noopener"><b>tıklayınız</b></a>.
                  </p>
                </li>
                
              </ul>
            </div>
          </div>

          {/* RIGHT: App Download Card */}
          <div className="col-md-6 osmanli-card-col">
            <div className="osmanli-app-card">
              {/* QR Code - desktop only */}
              <div className="osmanli-qr">
                <img src="/images/qrcode.png" alt="QR Code" />
              </div>

              {/* Store Buttons */}
              <div className="osmanli-store-buttons">
                {/* Google Play önce (referans tasarım) */}
                <a href="https://play.google.com/store/apps/details?id=com.matriksdata.osmanli&hl=tr" target="_blank" rel="noreferrer noopener">
                  <img src="/images/play-store-logo.png" alt="Google Play" className="osmanli-store-img" />
                </a>
                <a href="https://apps.apple.com/tr/app/osmanl%C4%B1-mobil/id1185449031?l=tr" target="_blank" rel="noreferrer noopener">
                  <img src="/images/app-store-logo.png" alt="App Store" className="osmanli-store-img" />
                </a>
              </div>

              {/* Info row */}
              <div className="osmanli-card-info">
                <span className="osmanli-info-icon">i</span>
                <p className="osmanli-card-info-text osmanli-desktop-text">
                  QR Kodunu tarayarak hesap açma işlemlerine hızlı bir şekilde başlayabilirsiniz!
                </p>
                <p className="osmanli-card-info-text osmanli-mobile-text">
                  Osmanlı Mobil uygulamasını indirerek hesap açma işlemlerine hızlı bir şekilde başlayabilirsiniz!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
